import React from 'react';
import './PrivacyPolicy.css'; // Import CSS from correct path

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h2>Privacy Policy</h2>
      <p>
        Effective Date: 3 June 2024
      </p>
      <p>
        Welcome to our Weather App. Your privacy is important to us. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you use our application.
      </p>
      <h3>Information We Collect</h3>
      <h4>Personal Information</h4>
      <ul>
        <li>
          <strong>Location Data:</strong> We collect your approximate or precise location information to provide accurate weather forecasts based on your current location.
        </li>
        <li>
          <strong>Contact Information:</strong> If you contact us via email or other communication channels, we may collect your name, email address, and any other information you provide voluntarily.
        </li>
      </ul>
      <h4>Non-Personal Information</h4>
      <p>
        We may also collect non-personal information that does not directly identify you, such as usage data (information about your interactions with our app, such as pages visited, features used, and other statistics).
      </p>
      <h3>How We Use Your Information</h3>
      <p>
        We use the information we collect for purposes including providing weather forecasts, improving our services, and communicating with you to respond to inquiries and provide customer support.
      </p>
      <h3>Disclosure of Your Information</h3>
      <p>
        We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this Privacy Policy or as required by law.
      </p>
      <h3>Data Security</h3>
      <p>
        We implement reasonable security measures to protect the security of your personal information. However, please be aware that no method of transmission over the internet or method of electronic storage is 100% secure.
      </p>
      <h3>Your Choices and Rights</h3>
      <ul>
        <li>
          <strong>Location Services:</strong> You can control location services through your device settings.
        </li>
        <li>
          <strong>Access and Update:</strong> You may access and update your personal information by contacting us.
        </li>
      </ul>
      <h3>Children's Privacy</h3>
      <p>
        Our Weather App is not directed to children under the age of 13. We do not knowingly collect personal information from children under 13. If we learn that we have collected personal information from a child under 13, we will take steps to delete such information.
      </p>
      <h3>Changes to This Privacy Policy</h3>
      <p>
        We may update this Privacy Policy periodically to reflect changes in our practices and legal requirements. We will notify you of any changes by posting the updated Privacy Policy on this page.
      </p>
      <h3>Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy or our data practices, please contact us at <a href="mailto:vishalkumar09837@gmail.com">vishalkumar09837@gmail.com</a>
      </p>
    </div>
  );
};

export default PrivacyPolicy;
